// extracted by mini-css-extract-plugin
module.exports = {"subjectCard":"SubjectCard_subjectCard__1_2MF","icon":"SubjectCard_icon__VjMDD","title":"SubjectCard_title__YAC12"};